import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  selectBusinessPrioritiesUserInfo,
  selectIsBusinessPrioritiesPreviousFYearSelected,
} from 'partner360/features/businessPriorities/model'

import { BusinessPrioritiesBanner } from '../../businessPrioritiesBanner'
import { BusinessPrioritiesControls } from '../../businessPrioritiesControls'
import { BusinessPrioritiesListHeader } from '../../businessPrioritiesListHeader'
import { BusinessPrioritiesTable } from '../../businessPrioritiesTable'

interface IBusinessPrioritiesListViewProps {
  fYear: number
  market: string
  publishDate?: string
}

export const BusinessPrioritiesListView: FC<IBusinessPrioritiesListViewProps> = ({
  fYear,
  market,
  publishDate,
}) => {
  const userInfo = useSelector(selectBusinessPrioritiesUserInfo)
  // Write actions always target the current FY, so any other FY is view-only.
  const isReadOnly = useSelector(selectIsBusinessPrioritiesPreviousFYearSelected)

  const isWorldWide = useMemo(() => userInfo?.viewType === 'WorldWide', [userInfo])
  const canPublish = useMemo(
    () => userInfo?.availableActions.includes('publish') ?? false,
    [userInfo]
  )

  return (
    <>
      <div>
        <BusinessPrioritiesListHeader
          fYear={fYear}
          publishDate={publishDate}
          isReadOnly={isReadOnly}
        />
      </div>

      <BusinessPrioritiesControls />

      {isWorldWide && !isReadOnly && (
        <BusinessPrioritiesBanner isWorldwide={true} canPublish={canPublish} />
      )}

      <BusinessPrioritiesTable isWorldwide={isWorldWide} market={market} isReadOnly={isReadOnly} />
    </>
  )
}

BusinessPrioritiesListView.displayName = 'BusinessPrioritiesListView'

export default BusinessPrioritiesListView
